import React, { useCallback, useRef, useState } from "react";
import { Row, Col, Button } from "reactstrap";

import {
  AudioPlayer,
  Intl,
  Select,
  Checkbox,
  ConfirmationModal,
  AudioFavouriteModal,
  UploadFileModal,
  AudioContainer,
} from "components";
import bg from "assets/img/step3Bg.png";

export default ({
  mailboxDisabled,
  formDisabled,
  values,
  onFormChange,
  onToggleConfirmTtsModal,
  onToggleSaveFavouriteModal,
  handleCustomAlert,
  validateCheck,
}) => {
  const [mailboxUploadModalOpened, setMailboxUploadModalOpened] = useState(
    false
  );
  const [
    mailboxFavouriteModalOpened,
    setMailboxFavouriteModalOpened,
  ] = useState(false);
  const [
    confirmMailboxChangeModalOpened,
    setConfirmMailboxChangeModalOpened,
  ] = useState(false);
  const onCancelMailboxChangeCbRef = useRef(null);

  const toggleMailboxModal = useCallback(() => {
    if (values.voicemailMediaAudioSrc === "localFile") {
      setMailboxUploadModalOpened((state) => !state);
    }
    if (values.voicemailMediaAudioSrc === "favourites") {
      // onFormChange("singleFile", values.mailboxFile);
      setMailboxFavouriteModalOpened((state) => !state);
    }
  }, [values]);

  const setMailboxFileValues = useCallback(
    (fileValues) => {
      if (
        values.voicemailMediaAudioSrc === "localFile" ||
        values.voicemailMediaAudioSrc === "favourites"
      ) {
        onFormChange("mailboxFile", fileValues.mailboxFile);
      }
      toggleMailboxModal();
    },
    [values, toggleMailboxModal, onFormChange]
  );

  const closeConfirmMailboxChangeModal = useCallback(() => {
    if (onCancelMailboxChangeCbRef.current)
      onCancelMailboxChangeCbRef.current();
    setConfirmMailboxChangeModalOpened(false);
  }, []);

  const clearMailboxAudio = useCallback(() => {
    if (values.mailboxFile) onFormChange("mailboxFile", null);

    onCancelMailboxChangeCbRef.current = null;
    closeConfirmMailboxChangeModal(false);
  }, [values, closeConfirmMailboxChangeModal, onFormChange]);

  const openMailboxConfirmChangeModal = useCallback(
    (cancelCb) => {
      if (values.mailboxFile) {
        setConfirmMailboxChangeModalOpened(true);
        onCancelMailboxChangeCbRef.current = cancelCb;
      } else {
        onCancelMailboxChangeCbRef.current = null;
      }
    },
    [values]
  );

  return (
    <>
      <Row className="mt-md-5">
        <Col md className="offset-md-1">
          <Checkbox
            field="voicemail"
            label="enableMailbox"
            disabled={formDisabled}
            onElementClick={() => handleCustomAlert(true)}
            onChange={(value) => {
              validateCheck(value);
              if (!value && values.voicemailMediaAudioSrc) {
                onFormChange("voicemailMediaAudioSrc", null);
                onFormChange("mailboxFile", null);
              }
            }}
          />
        </Col>
      </Row>

      <Row className="answering mt-2">
        <Col md className="d-flex flex-column justify-content-center">
          <img
            src={bg}
            alt="..."
            className="answering-triangle img-fluid d-none d-md-block w-100"
            style={{ height: 130 }}
          />

          <Row noGutters className="w-100">
            <Col md={10} xs={12} className="m-auto">
              <Select
                field="voicemailMediaAudioSrc"
                placeholder="answeringAudioSource2"
                translateOptions
                isDisabled={mailboxDisabled}
                showErrors={false}
                onElementClick={() => handleCustomAlert(true)}
                options={[
                  { id: "tts", name: "tts" },
                  { id: "favourites", name: "favourites" },
                  { id: "localFile", name: "localFile" },
                ]}
                onChange={(val, prevValue) => {
                  if (val === "tts") {
                    onToggleConfirmTtsModal();
                    onFormChange("voicemailMediaAudioSrc", prevValue);
                  } else {
                    openMailboxConfirmChangeModal(() =>
                      onFormChange("voicemailMediaAudioSrc", prevValue)
                    );
                  }
                }}
              />
              <div className="mt-4">
                <Button
                  color="app-default"
                  size="app-sm"
                  block
                  disabled={!values.voicemailMediaAudioSrc}
                  onClick={toggleMailboxModal}
                >
                  <Intl id="setAudioBtn" />
                </Button>
              </div>
            </Col>
          </Row>
        </Col>

        <Col
          md
          className="d-flex flex-column justify-content-center mt-4 mt-md-0"
        >
          {values.voicemailMediaAudioSrc && values.mailboxFile && (
            <AudioContainer
              onSaveFavourite={() => onToggleSaveFavouriteModal("mailboxFile")}
            >
              <AudioPlayer src={values.mailboxFile.uri} />
            </AudioContainer>
          )}
        </Col>
      </Row>

      {values.voicemailMediaAudioSrc === "localFile" &&
        mailboxUploadModalOpened && (
          <UploadFileModal
            entityId={values.id}
            type="voicemail"
            values={{
              messageType: "simple_message",
              audioSource: values.voicemailMediaAudioSrc,
            }}
            title={`mailbox_${values.voicemailMediaAudioSrc}`}
            open={mailboxUploadModalOpened}
            onClose={toggleMailboxModal}
            onSubmit={setMailboxFileValues}
            lField="mailboxFile"
          />
        )}
      {values.voicemailMediaAudioSrc === "favourites" &&
        mailboxFavouriteModalOpened && (
          <AudioFavouriteModal
            values={{
              ...values,
              messageType: "simple_message",
              // audioSource: values.voicemailMediaAudioSrc,
            }}
            title={`mailbox_${values.voicemailMediaAudioSrc}`}
            open={mailboxFavouriteModalOpened}
            onClose={toggleMailboxModal}
            onSubmit={setMailboxFileValues}
            field="mailboxFile"
          />
        )}

      {confirmMailboxChangeModalOpened && (
        <ConfirmationModal
          title="answeringChangeTitle"
          subtitle="answeringChangeSubtitle"
          open={confirmMailboxChangeModalOpened}
          onClose={closeConfirmMailboxChangeModal}
          onConfirm={() => clearMailboxAudio(values)}
        />
      )}
    </>
  );
};
